declare global {
  interface Window {
    App: Record<string, unknown>;
  }
}

/**
 * @deprecated We should rely not on this
 */
export const getGlobalAppVar = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  if (!window.App) {
    window.App = {};
  }

  return window.App;
};
